import { Disclosure, Transition } from '@headlessui/react';
import React from 'react';
import AgendaFactory from '../components/complexComponents/AgendaFactory';
import ToggleInput from '../components/inputs/ToggleInput';
import FormLabel from '../components/basicComponents/FormLabel';

const defaultTransition = {
	enter: 'transition duration-1000 ease-in-out',
	enterFrom: 'transform opacity-0',
	enterTo: 'transform opacity-100',
	leave: 'transition duration-600 ease-in-out',
	leaveFrom: 'transform opacity-100',
	leaveTo: 'transform opacity-0',
};

/*
* Main function
*/
function EarlyVoteForm({
	portal,
	formData,
	setFormData,
	colors,
	translate,
	/* OPTIONAL PROPS */
	isOptional,
	styleLIST,
	styleTransition,
	classNameDIV = 'space-y-5',
	classNameBTN = 'flex font-lato space-x-4 items-center w-full',
	classNameLIST = 'md:pl-8 pt-1 pb-4 space-y-8 md:text-lg',
	// classNameLABEL = 'w-max font-bold text-lg md:text-xl w-full',
}) {
	/* Default values for the styles */
	const defaultStyleBTN = {
		color: colors?.text,
	};
	const defaultStyleLIST = {
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideTransition = { ...defaultTransition, ...styleTransition };
	const overrideStyleLIST = { ...defaultStyleLIST, ...styleLIST };

	/* Function to handle special change logic */
	const handleChange = (agendaId, agendaValue, voteOrder) => {
		setFormData({
			...formData,
			votes: [
				...formData.votes.filter(v => v.id !== agendaId),
				{
					...formData.votes.find(v => v.id === agendaId),
					id: agendaId,
					value: agendaValue,
					orderIndex: voteOrder
				},
			]
		});
	};

	const activeVotes = active => {
		setFormData({
			...formData,
			votesIsActive: active,
		});
	};
	const getAgendaValue = id => {
		if (formData?.votes?.find(v => v.id === id)) {
			return formData?.votes?.find(v => v.id === id).value;
		}
		return null;
	};
	if (!isOptional) {
		return <div as='div' className={classNameDIV}>
			<div className={classNameBTN} style={defaultStyleBTN}>
				<FormLabel
					text={portal?.config?.forms?.voteSense}
					colors={colors}
					translate={translate}
				/>
			</div>
			<div
				className={classNameLIST}
				style={overrideStyleLIST}
			>
				{portal?.council?.agendas?.map(agenda => <AgendaFactory
					key={agenda.id}
					agenda={agenda}
					value={getAgendaValue(agenda.id)}
					onChange={value => handleChange(agenda.id, value, agenda.orderIndex)}
					colors={colors}
					translate={translate}
				/>)}
			</div>
		</div>;
	}

	return <Disclosure as='div' className={classNameDIV}>
		{({ open }) => (
			<>
				<div className={classNameBTN} style={defaultStyleBTN}>
					<FormLabel
						text={portal?.config?.forms?.voteSense}
						colors={colors}
						translate={translate}
					/>
					<Disclosure.Button as='div'>
						<ToggleInput value={open} colors={colors} onChange={() => activeVotes(!open)} />
					</Disclosure.Button>
				</div>
				<Transition
					enter={overrideTransition.enter}
					enterFrom={overrideTransition.enterFrom}
					enterTo={overrideTransition.enterTo}
					leave={overrideTransition.leave}
					leaveFrom={overrideTransition.leaveFrom}
					leaveTo={overrideTransition.leaveTo}
				>

					<Disclosure.Panel
						className={classNameLIST}
						style={overrideStyleLIST}
					>
						{portal?.council?.agendas?.map(agenda => <AgendaFactory
							key={agenda.id}
							agenda={agenda}
							value={getAgendaValue(agenda.id)}
							onChange={value => handleChange(agenda.id, value, agenda.orderIndex)}
							colors={colors}
							translate={translate}
						/>)}
					</Disclosure.Panel>
				</Transition>
			</>
		)}
	</Disclosure>;
}

export default EarlyVoteForm;
